<template>
    <div v-if="currentDetailPageJson.type == 'tabs' && !currentDetailPageJson.options.hidden">
        <el-tabs type="border-card" :tab-position="currentDetailPageJson.options.tabposition" :class="currentDetailPageJson.options.customClass" v-model="currentDetailTabsModel" @tab-click="tabClick">
            <el-tab-pane label="列表" name="列表" v-if="istodoPage">
            </el-tab-pane>
            <el-tab-pane :style="{height: pageHeight, transition: 'all 0.3s ease-in 0s',overflowX: 'hidden'}" v-for="(element, index) in currentDetailPageJson.columns" :key="index" :label="element.label" style="overflow-y:auto" :name="element.label">
                 <recursiveComponent v-if="currentDetailTabsModel == element.label" ref="recursiveComponent" :jsonData="element"></recursiveComponent>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import recursiveComponent from "./recursiveComponent"
export default {
    name:"detailsPageTabs",
    props:['pageHeight','istodoPage'],
    components:{recursiveComponent},
    data(){
        return{

        }
    },
    computed:{
        //当前应用详情页json
        currentDetailPageJson(){
            return this.$store.state.currentDetailPageJson
        },
        //当前详情页tabs选中值
        currentDetailTabsModel:{
            get: function() {
                return this.$store.state.currentDetailTabsModel
            },
            set: function(val) {
                this.$store.commit('setcurrentDetailTabsModel',val)
            }
        },
    },
    methods:{
        //tab选项卡点击
        tabClick(tab){
            if(tab.label == "列表"){
                this.$store.commit('setcurrentShowPage',1)
                this.$store.commit("setupdateMainTableData",true)
            }else{
                this.$store.commit('setisrequestChildTableData',false)
                this.$nextTick(()=>{
                    this.$store.commit('setisrequestChildTableData',true)
                })
            }
        },
    },
    mounted(){
  
    }
}
</script>

<style>

</style>